import WishGridItem from "./wish-grid-item/WishGridItem";
import {getRandomNumber} from "../../../../util/utils";
import WishGridItemSkeleton from "./wish-grid-item-skeleton/WishGridItemSkeleton";
import {IWishesResponse} from "../../../../store/wish/Helper";
import {FC} from "react";
import {Grid} from "@mui/material";
import {SxProps} from "@mui/system";
import {Theme} from "@mui/material/styles";

interface Props {
    wishes: IWishesResponse
    handleOpenWishDetails: (wishId: string) => void
    loading: boolean
    sx?: SxProps<Theme>
}

const WishGrid: FC<Props> = (props) => {
    const renderWishes = props.wishes.data.map((wish) => (
        <WishGridItem key={wish.id} wish={wish}
                      handleOpenWishDetails={() => props.handleOpenWishDetails(wish.id)}/>
    ))

    const renderWishSkeletons = Array.from(Array(getRandomNumber(3, 8)).keys()).map((skeleton, idx) => (
        <WishGridItemSkeleton key={`wish-grid-item-skeleton-${idx}`}/>
    ))
    return (
        <Grid container justifyContent="space-around" sx={{...props.sx}}>
            {renderWishes}
            {props.loading ? renderWishSkeletons : null}
        </Grid>
    )
}

export default WishGrid
